import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { NavigationTabTypes } from 'widgets/poker-cash-games-widget/types';
import { LearnMoreIcon } from '@swf/poker';

import HoldemBanner from '../../../assets/banner-holdem.embed.svg';
import OmahaBanner from '../../../assets/banner-omaha.embed.svg';
import BackgroundImage from '../../../assets/game-background.svg';
import { NavigationTabs } from '../../../types';
import GameSelector from '../GameSelector/GameSelector';

import {
  TXTCLI_Cash_games_are_the_purest_form_ELL,
  TXTCLI_How_to_play_Omaha,
  TXTCLI_How_to_play_Texas_HoldXem
} from './GameView.messages.json';
import styles from './GameView.scss';

const GAME_VIEW_DATA = {
  HOLDEM: {
    banner: HoldemBanner,
    linkTitle: TXTCLI_How_to_play_Texas_HoldXem,
    link: '/poker/games/texas-holdem/'
  },
  OMAHA: {
    banner: OmahaBanner,
    linkTitle: TXTCLI_How_to_play_Omaha,
    link: '/poker/games/omaha/'
  }
};

interface Props {
  gameVariation: NavigationTabTypes;
}

const GameView: React.FC<Props> = ({ gameVariation }) => {
  const brandId = useSelector(select.cms.getBrandId);
  const isSisalBrand = brandId === BrandTypes.SISAL;

  return (
    <div data-testid={`game-view-${gameVariation}`} className={styles.container}>
      <div
        className={classNames(
          styles.backgroundImage,
          styles[gameVariation.toLowerCase() as keyof typeof styles]
        )}
      >
        <BackgroundImage />
      </div>
      <div
        className={classNames(styles.information, {
          [styles.omaha]: gameVariation === NavigationTabs.OMAHA
        })}
      >
        <img
          src={`${GAME_VIEW_DATA[gameVariation].banner}`}
          loading="eager"
          alt={`${gameVariation} playing cards`}
          className={classNames(styles.banner, {
            [styles.omaha]: gameVariation === NavigationTabs.OMAHA
          })}
        />
        <div className={styles.description}>
          <Translation {...TXTCLI_Cash_games_are_the_purest_form_ELL} tagName="span" />
        </div>
        <StarsLink
          target="_blank"
          href={GAME_VIEW_DATA[gameVariation].link}
          className={classNames(styles.link, {
            [styles.sisalLink]: isSisalBrand
          })}
        >
          <Translation {...GAME_VIEW_DATA[gameVariation].linkTitle} tagName="span" />
          <LearnMoreIcon />
        </StarsLink>
      </div>

      <GameSelector />
    </div>
  );
};

export default GameView;
